import { render, staticRenderFns } from "./ChatRooms.vue?vue&type=template&id=10bbbba6&"
import script from "./ChatRooms.vue?vue&type=script&lang=js&"
export * from "./ChatRooms.vue?vue&type=script&lang=js&"
import style0 from "./ChatRooms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports